import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

const PAST = 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';

function getGTCookie() {
  const match = document.cookie.match(/googtrans=\/\w+\/(\w+)/);
  return match ? match[1] : 'en';
}

function setGTCookie(langCode) {
  const val = `/en/${langCode}`;
  const host = window.location.hostname;
  document.cookie = `googtrans=${val}; path=/`;
  document.cookie = `googtrans=${val}; path=/; domain=${host}`;
  document.cookie = `googtrans=${val}; path=/; domain=.${host}`;
}

function clearGTCookie() {
  const host = window.location.hostname;
  document.cookie = `googtrans=; ${PAST}`;
  document.cookie = `googtrans=; ${PAST}; domain=${host}`;
  document.cookie = `googtrans=; ${PAST}; domain=.${host}`;
}

export function LanguageProvider({ children }) {
  const [appLanguage, setAppLanguageState] = useState(
    () => localStorage.getItem('app_language') || 'en'
  );

  // On mount: if saved language is French but the GT cookie is missing/wrong, set it and reload.
  // GT reads the cookie on page load and auto-translates — no select manipulation needed.
  useEffect(() => {
    const saved = localStorage.getItem('app_language') || 'en';
    if (saved !== 'en' && getGTCookie() !== saved) {
      setGTCookie(saved);
      window.location.reload();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setAppLanguage = useCallback((langCode) => {
    localStorage.setItem('app_language', langCode);
    setAppLanguageState(langCode);
    if (langCode === 'en') {
      clearGTCookie();
    } else {
      setGTCookie(langCode);
    }
    window.location.reload();
  }, []);

  return (
    <LanguageContext.Provider value={{ appLanguage, setAppLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
